/**
 * Created by zhouxin on 2019-04-15
 **/
import { getToken } from './auth';

const USERNAME = 'username';

export function isToken() {
  // console.log('getToken', getToken())
  if (getToken() === 'undefined') return false;
  return !!getToken();
}

export function setUserName(username) {
  window.sessionStorage.setItem(USERNAME, username);
}

export function getUserName() {
  return window.sessionStorage.getItem(USERNAME);
}



// WEBPACK FOOTER //
// ./src/utils/users.js